// Short confirmations as Basecoat toasts. We build the element ourselves (text nodes only, spec §7.3)
// rather than call the toaster's toast(), which writes its arguments into innerHTML; Basecoat's
// script then picks it up, times it out and removes it.
import { h, icon, ICONS } from './dom';

export function toast(title: string, category: 'success' | 'info' = 'success') {
  const toaster = document.getElementById('toaster');
  if (!toaster) return;
  toaster.append(h('div', { class: 'toast', role: 'status', 'aria-atomic': 'true', 'data-category': category },
    h('div', { class: 'toast-content' }, icon(category === 'success' ? ICONS.check : ICONS.info, 16), h('section', null, h('h2', null, title)))));
}
